import { updatePageRow } from "../../../paginator";
import { _patch, _post, _delete } from "../../../resources";
import { updateList, createList, deleteList } from "../../../lists";
import { resources } from "constants/resources";

const updateApplicantsRows = (resource, payload) => {
  return updatePageRow("challenges_application", payload, "user_id");
};

const updateParticipantsRows = (resource, payload) => {
  return updatePageRow("challenges_participant", payload, "user_id");
};

const patchAndUpdateApplicants = _patch(updateList, updateApplicantsRows);
const postAndUpdateParticipants = _post(createList, updateParticipantsRows);
const deleteAndUpdateParticipants = _delete(deleteList, updateParticipantsRows);

export const acceptApplicantsUpdatePage = (id = null, params = {}) => {
  const key = "application_accepted";
  const resource = resources[key];
  return patchAndUpdateApplicants(key, `${resource.url}/${id}`, params);
};

export const addToTeamUpdatePage = (params = {}) => {
  const key = "users_team";
  const resource = resources[key];
  return postAndUpdateParticipants(key, resource.url, params);
};

export const removeFromTeamUpdatePage = (params = {}) => {
  const key = "users_team";
  const resource = resources[key];
  return deleteAndUpdateParticipants(key, resource.url, params);
};

// const postInviteMemberToTeam = _post(createList, updateInvitationStatus);

// export const adminInviteUserToTeam = (params = {}) => {
//   const key = "admin_invitation";
//   const resource = resources[key];
//   return postInviteMemberToTeam(key, resource.url, params);
// };

// const updateInvitationStatus = (resource, payload) => {
//   return recieveAdminInvitation("admin_invitation", payload);
// };

// export const recieveAdminInvitation = (resource, payload) => ({
//   type: "RECIEVE_ADMIN_INVITATION",
//   resource,
//   payload
// });



// WEBPACK FOOTER //
// ./src/actions/components/dashboard/challenge/admin.js